import { render, staticRenderFns } from "./ChairConfig.vue?vue&type=template&id=bf242754&scoped=true&"
import script from "./ChairConfig.vue?vue&type=script&lang=js&"
export * from "./ChairConfig.vue?vue&type=script&lang=js&"
import style0 from "./ChairConfig.vue?vue&type=style&index=0&id=bf242754&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf242754",
  null
  
)

export default component.exports